import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CampaignProvider } from './contexts/CampaignContext/CampaignContext';
import { CookieConsentProvider } from './contexts/CookieConsentContext/CookieConsentContext';
import { Layout } from './components-new/Layout/Layout';
import { ScrollToTop } from './components-new/ScrollToTop/ScrollToTop';
import { Home } from './pages/Home/Home';
import { About } from './pages/About/About';
import { Services } from './pages/Services/Services';
import { Projects } from './pages/Projects/Projects';
import { Contact } from './pages/Contact/Contact';
import { PrivacyPolicy } from './pages/PrivacyPolicy/PrivacyPolicy';
import { getLangFromPath, getRouterBasename } from './utils/languageUtils';
import './styles/appearance.less';

// English lives under /en, Bulgarian at the root. Using the router basename keeps
// every <Link to="/about"> in the app language-aware without touching call sites.
const basename = getRouterBasename(getLangFromPath(window.location.pathname));

const App = () => {
  return (
    <HelmetProvider>
      <CookieConsentProvider>
        <CampaignProvider>
          <Router basename={basename}>
            <ScrollToTop />
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services" element={<Services />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              </Routes>
            </Layout>
          </Router>
        </CampaignProvider>
      </CookieConsentProvider>
    </HelmetProvider>
  );
};

export default App;
